import React, { useEffect } from 'react'
import { IFlatNotification, INotification, NotificationSenderType, NotificationStatus, NotificationTarget, NotificationType } from '../../../types/notification';
import { IAction } from '../../../types/action';

interface INotificationProps {
    handleSaveNotification: (e: React.FormEvent<HTMLFormElement>, action: INotification) => void;
    handleDeleteNotification: (id?: number) => void;
    handleSendNotification: () => void;
    isAddNotification: boolean;
    isDelete: boolean;
    setIsDelete: React.Dispatch<React.SetStateAction<boolean>>;
    currentOption: number[];
    setCurrentOption: React.Dispatch<React.SetStateAction<number[]>>;
    isProcessRunning: boolean;
    notifications: INotification[];
    actions: IAction[];
}

const Notification = ({ handleSaveNotification, handleDeleteNotification, handleSendNotification, currentOption, isAddNotification, isDelete, setIsDelete, isProcessRunning, notifications, actions }: INotificationProps) => {
    const blankAction: IFlatNotification = {
        title: '',
        description: '',
    }

    const [currentNotification, setCurrentNotification] = React.useState<IFlatNotification>(blankAction);
    const [title, setTitle] = React.useState<string>('New Notification');
    const [senderType, setSenderType] = React.useState<NotificationSenderType>('admin' as NotificationSenderType);

    useEffect(() => {
        if (isAddNotification) {
            setCurrentNotification(blankAction);
            setSenderType('admin' as NotificationSenderType);
            setTitle('New Notificaton');
        } else {
            if (notifications && currentOption.length === 2) {
                const notification = notifications[currentOption[1]];
                const flatNotification: IFlatNotification = {
                    id: notification.id,
                    date: notification.date ?? undefined,
                    title: notification.title,
                    description: notification.description,
                    action_id: notification.action_id ?? undefined,
                    system_notification_id: notification.system_notification_id ?? undefined,
                    admin_notification_id: notification.admin_notification_id ?? undefined,
                    code: notification.system_notification?.code ?? undefined,
                    type: (notification.system_notification?.type || notification.admin_notification?.type) ?? undefined,
                    target: notification.admin_notification?.target as NotificationTarget ?? undefined,
                    status: notification.admin_notification?.status as NotificationStatus ?? undefined,
                }
                setSenderType((notification.admin_notification_id ? 'admin' : 'system') as NotificationSenderType)
                setCurrentNotification(flatNotification);
                setTitle(notification.title);
            }
        }
    }, [isAddNotification, currentOption, notifications]); // eslint-disable-line

    if (!currentNotification) return <p>Loading ...</p>
    return (
        <div className='imm_admin__content'>
            <div className='content_head'>
                <h3>{title}</h3>
            </div>

            <form onSubmit={(e) => handleSaveNotification(e, { senderType, ...currentNotification })} className='content_form'>
                <div className='field'>
                    <label htmlFor='notification'>Title <span className='field__required'>*</span></label>
                    <input id='notification' name='notification' placeholder='Enter notification title' value={currentNotification.title || ''} onChange={(e) => setCurrentNotification({ ...currentNotification, title: e.target.value })} />
                </div>

                <div className='field'>
                    <label htmlFor='description'>Description <span className='field__required'>*</span></label>
                    <textarea id='description' name='description' placeholder='Enter notification description' rows={6} value={currentNotification.description || ''} onChange={(e) => setCurrentNotification({ ...currentNotification, description: e.target.value })}></textarea>
                </div>

                {currentNotification.id && senderType === 'system' && (<div className='field'>
                    <label htmlFor='code'>Code</label>
                    <input id='code' name='code' disabled={currentNotification.id !== undefined} placeholder='Enter action code' value={currentNotification.code || ''} />
                </div>)}

                <div className='field'>
                    <label htmlFor='sender'>Sender Type</label>
                    <select disabled={currentNotification.id !== undefined} id='sender' name='sender' value={senderType} onChange={(e) => setSenderType(e.target.value as NotificationSenderType)}>
                        <option value='admin'>Admin</option>
                        <option value='system'>System</option>
                    </select>
                </div>

                {currentNotification.id && senderType === "admin" && (<div className='field'>
                    <label htmlFor='status'>Status</label>
                    <select disabled={true} id='status' name='status' value={currentNotification.status || ''} onChange={(e) => setCurrentNotification({ ...currentNotification, status: e.target.value as NotificationStatus })}>
                        <option value=''>Select status</option>
                        <option value='created'>Created</option>
                        <option value='sent'>Sent</option>
                    </select>
                </div>)}

                <div className='field'>
                    <label htmlFor='type'>Type <span className='field__required'>*</span></label>
                    <select id='type' name='type' value={currentNotification.type || ''} onChange={(e) => setCurrentNotification({ ...currentNotification, type: e.target.value as NotificationType })}>
                        <option value=''>Select type</option>
                        {senderType === 'admin' && (
                            <>
                                <option value='program'>Program</option>
                                <option value='general'>General</option>
                                <option value='draw'>Draw</option>
                                <option value='status'>Status</option>
                                <option value='promotion'>Promotion</option>
                            </>
                        )}

                        {senderType === 'system' && (
                            <>
                                <option value='system'>System</option>
                                <option value='consult'>Consult</option>
                                <option value='subscription'>Subscription</option>
                            </>
                        )}
                    </select>
                </div>

                {senderType === 'admin' && (<div className='field'>
                    <label htmlFor='target'>Target <span className='field__required'>*</span></label>
                    <select id='target' name='target' value={currentNotification.target || ''} onChange={(e) => setCurrentNotification({ ...currentNotification, target: e.target.value as NotificationTarget })}>
                        <option value=''>Select target</option>
                        <option value='both'>Both</option>
                        <option value='free'>Free</option>
                        <option value='subscribers'>Subscribers</option>
                    </select>
                </div>)}

                <div className='field'>
                    <label htmlFor='action'>Action <span className='field__required'>*</span></label>
                    <select id='action' name='action' value={currentNotification.action_id || ''} onChange={(e) => setCurrentNotification({ ...currentNotification, action_id: parseInt(e.target.value) })}>
                        <option value=''>Select action</option>
                        {actions.map((action, index) => (
                            <option key={index} value={action.id}>{action.name}</option>
                        ))}
                    </select>
                </div>

                <div className='actions'>
                    <button disabled={isProcessRunning || currentNotification.status === 'sent'} className='delete_btn' type="button" onClick={() => handleDeleteNotification(currentNotification.id)}>{!currentNotification.id ? 'Cancel' : 'Delete'}</button>
                    <button disabled={isProcessRunning || currentNotification.status === 'sent'} className='save_btn' type='submit'>{isProcessRunning ? <i className='imm_admin__process_loader' /> : !currentNotification.id ? 'Create' : 'Save'}</button>
                    {currentNotification.id && senderType === 'admin' && (<button disabled={isProcessRunning || currentNotification.status === 'sent'} className='send_btn' type='button' onClick={handleSendNotification}>{isProcessRunning ? <i className='imm_admin__process_loader' /> : currentNotification.status === 'sent' ? 'Notification sent' : 'Send'}</button>)}
                </div>
            </form>
        </div>
    )
}

export default Notification;